var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-overlay",
        { attrs: { absolute: "", value: _vm.orderGetting } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      ),
      _c("base-snackbar", {
        attrs: { errors: _vm.orderGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderGetErrors = $event
          }
        }
      }),
      _c(
        "v-toolbar",
        {
          staticClass: "mb-5",
          attrs: { color: "primary", dark: "", rounded: "", dense: "" }
        },
        [
          _c("span", [_vm._v("Order Details")]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { color: "error", dark: "", "x-small": "" },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "orders.table" })
                }
              }
            },
            [_c("span", [_vm._v("back")])]
          ),
          _vm.updatable
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { color: "purple darken-3", dark: "", "x-small": "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "orders.edit",
                        params: { orderId: _vm.$route.params.orderId }
                      })
                    }
                  }
                },
                [_c("span", [_vm._v("Update Status")])]
              )
            : _vm._e(),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                color: "purple darken-3",
                dark: "",
                "x-small": "",
                loading: _vm.orderPrintReceiptGetting
              },
              on: { click: _vm.generatePdf }
            },
            [_c("span", [_vm._v("Generate PDF")])]
          ),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                color: "purple darken-3",
                dark: "",
                "x-small": "",
                loading: _vm.gettingBillingStatement
              },
              on: { click: _vm.generateBillingStatement }
            },
            [_c("span", [_vm._v("Billing Statement")])]
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "purple darken-3", dark: "", "x-small": "" },
              on: {
                click: function($event) {
                  _vm.paymentTransactions = true
                }
              }
            },
            [_c("span", [_vm._v("ADD TRANSACTION")])]
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.orderData.orderStatusId === "CP"
                ? _c("v-alert", { attrs: { type: "success" } }, [
                    _c("span", [_vm._v("Complete")])
                  ])
                : _vm.orderData.orderStatusId === "PL"
                ? _c("v-alert", { attrs: { type: "info" } }, [
                    _c("span", [_vm._v("Parially Paid")])
                  ])
                : _vm.overDue < 0
                ? _c("v-alert", { attrs: { type: "error" } }, [
                    _c("span", [_vm._v("Invoice is overdue")])
                  ])
                : _vm.overDue < 3
                ? _c("v-alert", { attrs: { type: "warning" } }, [
                    _c("span", [_vm._v("invoice is almost due")])
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [
                      _vm._v("Order Id"),
                      _vm.orderData.poNumber
                        ? _c("span", [
                            _vm._v(" : PO# - " + _vm._s(_vm.orderData.poNumber))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _c("v-card-text", [_vm._v(_vm._s(_vm.orderData.id))])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Customer")]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s(
                        _vm.orderData.customer
                          ? _vm.$autoAbbriviate(_vm.orderData.customer.company)
                          : null || "N/A"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Project Code")]
                  ),
                  _vm.orderData.projectCode
                    ? _c("v-card-text", [
                        _vm._v(_vm._s(_vm.orderData.projectCode.project_code))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Address")]
                  ),
                  _c("v-card-text", [_vm._v(_vm._s(_vm.orderData.address))])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Invoice No.")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$intToInvoiceNumber(_vm.invoice.id)))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Invoice Date")]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s((_vm.invoice.invoice_date || "").dateFormat())
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Date Due")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s((_vm.dueDate || "").dateFormat()))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Amount Due")]
                  ),
                  _c("v-card-text", [_vm._v(_vm._s(_vm.amountDue.phpFormat()))])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Date Delivered")]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s((_vm.orderData.deliveryDate || "").dateFormat())
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Date Delivered")]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s(
                        (_vm.orderData.actualDeliveryDate || "").dateFormat()
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Delivered By")]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s(
                        _vm.generateEmployeeName(_vm.orderData.deliveredBy) ||
                          "N/A"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Co Deliverer")]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s(
                        _vm.generateEmployeeName(_vm.orderData.co_deliverer) ||
                          "N/A"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Address")]
                  ),
                  _c("v-card-text", [_vm._v(_vm._s(_vm.orderData.address))])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Shipping Fee")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.orderData.shipping_fee || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Order Date")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s((_vm.orderData.orderDate || "").dateFormat()))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Payment Type")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.orderData.paymentType || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Paid Date")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s((_vm.orderData.paidDate || "").dateFormat()))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Order Status")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s((_vm.orderData.status || {}).name || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Payment Terms")]
                  ),
                  _c("v-card-text", [_vm._v(_vm._s(_vm.paymentTerms))])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-subtitle",
                    { staticClass: "primary--text text-uppercase" },
                    [_vm._v("Notes")]
                  ),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.orderData.notes || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mt-5" },
        [
          _c(
            "v-container",
            [
              _c("v-simple-table", {
                attrs: { dense: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Item")]),
                            _c("th", [_vm._v("Discount")]),
                            _c("th", [_vm._v("Status")]),
                            _c("th", [_vm._v("Date Allocated")]),
                            _c("th", [_vm._v("Quantity")]),
                            _c("th", [_vm._v("Unit Price")]),
                            _c("th", [_vm._v("Amount")])
                          ])
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.orderDetails, function(item) {
                              return _c("tr", { key: item.id }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(item.stock.brand_name) +
                                      " " +
                                      _vm._s(item.stock.description)
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s((item.discount || 0).phpFormat())
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(item.order_detail_status_id))
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(item.date_allocated.dateFormat())
                                  )
                                ]),
                                _c("td", { attrs: { align: "right" } }, [
                                  _vm._v(
                                    _vm._s(item.quantity) +
                                      " " +
                                      _vm._s(item.unit)
                                  )
                                ]),
                                _c("td", { attrs: { align: "right" } }, [
                                  _vm._v(
                                    _vm._s((item.unit_price || 0).phpFormat())
                                  )
                                ]),
                                _c("td", { attrs: { align: "right" } }, [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        item.quantity *
                                          (item.unit_price - item.discount) || 0
                                      ).phpFormat()
                                    )
                                  )
                                ])
                              ])
                            }),
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { align: "right", colspan: "6" } },
                                [_c("strong", [_vm._v("TOTAL")])]
                              ),
                              _c("td", { attrs: { align: "right" } }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.amountDue.phpFormat()))
                                ])
                              ])
                            ])
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { eager: "", width: "800" },
          model: {
            value: _vm.paymentTransactions,
            callback: function($$v) {
              _vm.paymentTransactions = $$v
            },
            expression: "paymentTransactions"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                [
                  _c("payment-transactions", {
                    attrs: {
                      "order-data": _vm.orderData,
                      "order-details": _vm.orderDetails,
                      popup: _vm.paymentTransactions
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }